import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useColorModeValue,
} from '@chakra-ui/react';

/**
 * کامپوننت Modal قابل استفاده مجدد برای فرم‌ها
 * @param {Object} props - props کامپوننت
 * @param {boolean} props.isOpen - وضعیت باز/بسته بودن modal
 * @param {Function} props.onClose - تابع بستن modal
 * @param {string} props.title - عنوان modal
 * @param {React.ReactNode} props.children - محتوای modal
 * @param {Function} props.onSubmit - تابع ارسال فرم
 * @param {boolean} props.isLoading - وضعیت بارگذاری
 * @param {string} props.submitText - متن دکمه ارسال
 * @param {string} props.cancelText - متن دکمه لغو
 */
const CustomModal = ({
  isOpen,
  onClose,
  title,
  children,
  onSubmit,
  isLoading = false,
  submitText = 'ذخیره',
  cancelText = 'لغو',
  size = 'md',
  formRef = null,
  hideFooter = false,
}) => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.800', 'white');

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={size} isCentered>
      <ModalOverlay />
      <ModalContent bg={bgColor} color={textColor} dir="rtl">
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton right="auto" left={4} />
        <ModalBody>
          {children}
        </ModalBody>
        {!hideFooter && (
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              {cancelText}
            </Button>
            <Button 
              colorScheme="teal" 
              onClick={onSubmit}
              isLoading={isLoading}
              loadingText="در حال ذخیره..."
            >
              {submitText}
            </Button>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default CustomModal; 